enum ReportTypes {
  OverallPerformance = 'overall-performance',
}

export default ReportTypes;
